<template>
  <div>
    <b-modal id="visit-modal" title="Enter your notes:" @ok="addNewVisit()">
      <b-form-group label="Visit Date" label-class="control-label">
        <datepicker
          v-model="newNoteDate"
          class="bottom"
          :inputClass="{ 'form-control': true }"
          :typeable="true"
          format="MM/dd/yyyy"
        ></datepicker>
      </b-form-group>

      <b-form-group label="Type" label-class="control-label">
        <b-form-select
          id="types"
          v-model="newNoteTypeId"
          :options="types"
          value-field="siteVisitTypeId"
          text-field="name"
        ></b-form-select>
      </b-form-group>

      <b-form-textarea
        v-model="newNoteText"
        placeholder="Enter notes"
        :rows="3"
        :max-rows="6"
      />
    </b-modal>

    <table-widget
      :items="notes"
      :perPage="perPage"
      :totalRows="totalRows"
      :current-page.sync="currentPage"
      :filter.sync="filter"
    >
      <template slot="buttons">
        <b-button class="ml-2" v-b-modal.visit-modal v-if="canAddNewNote()"
          ><font-awesome-icon icon="plus" /> New Visit</b-button
        >
      </template>
      <template slot="content">
        <b-table
          striped
          :items="notes"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          @filtered="onFiltered"
          sort-by="createdDate"
          sortDesc
          small
        >
          <template slot="date" slot-scope="data">
            {{ data.item.date | formatDate }}
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import siteVisitsApi from "../../api/site-visits";
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import TableWidget from "../table-widget";

export default {
  data() {
    return {
      notes: [],
      types: [],
      newNoteText: null,
      newNoteDate: null,
      newNoteTypeId: null,
      fields: [
        { key: "date", label: "Date", sortable: true },
        { key: "siteVisitType.name", label: "Type", sortable: true },
        { key: "createdBy", sortable: true },
        { key: "notes" },
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
    };
  },

  components: {
    "table-widget": TableWidget,
  },

  props: {
    siteId: {
      required: true,
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addNewVisit() {
      var that = this;
      if (this.newNoteText) {
        siteVisitsApi
          .postSiteVisit({
            siteId: this.siteId,
            notes: this.newNoteText,
            date: this.newNoteDate,
            siteVisitTypeId: this.newNoteTypeId,
          })
          .then(function (response) {
            that.notes.push(response.data);
            that.newNoteText = null;
            that.newNoteDate = null;
            that.newNoteTypeId = null;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    canAddNewNote: function () {
      // TODO: Replace with role-checks mixin, check for site manager role
      return _.find(this.user.userRoles, function (userRole) {
        return (
          userRole === "Placements.Admin" ||
          userRole === "Placements.ContractManager" ||
          userRole === "Placements.Advisor"
        );
      });
    },
  },

  created() {
    var that = this;
    siteVisitsApi
      .getForSite(this.siteId)
      .then(function (response) {
        that.notes = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    siteVisitsApi.getTypes().then((response) => {
      this.types = response.data;
    });
  },
};
</script>

<style scoped>
.bottom .vdp-datepicker__calendar {
  position: absolute;
  top: 33px;
}
</style>
